import React from 'react';
import AboutMe from '../features/Profile/components/AboutMe';

function AboutMePage() {
  return (
    <div>
      <AboutMe />
    </div>
  );
}

export default AboutMePage;
